export enum ActionTypes {
  FETCH_NOTIFICATIONS = "FETCH_NOTIFICATIONS",
  SET_NOTIFICATIONS = "SET_NOTIFICATIONS",
  SET_NOTIF_ERROR = "SET_NOTIF_ERROR",
}
